const  aboutHeader = {
    ru: {
        aboutHeader:"О нас" 
    },
    eng: {
        aboutHeader:"About us" 
    }
}

export default aboutHeader